import { AuditItem } from "@deliverr/crossdock-service-client";

export const mapBoxAuditItemsToList = (auditItems: AuditItem[] = []) => {
  return auditItems.map(({ barcode, dsku, qty, productName }) => ({
    barcode,
    description: productName ?? dsku ?? "",
    qty,
  }));
};
